<template>
    <div class="ocr props-group">
      <el-form-item label="控件属性">
        <el-select v-model="component.properties.ocr.type">
          <el-option v-for="item in ocrType" :label="item.label" :key="item.value" :value="item.value"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item class="ocr-rules" label="设置匹配规则" label-width="100px">
        <el-button @click="setRelationRules">设置匹配规则</el-button>
      </el-form-item>

      <el-dialog class="ocr-rules-dialog"
                 :visible.sync="ocrDialog.visible"
                 :close-on-click-model="false"
                 append-to-body
                 title="设置匹配规则"
                 @open="openDialog"
                 @close="closeDialog"
                 width="40%">
        <el-form ref="ocrForm" label-width="45%" label-position="left" :model="rules" :rules="formRules">
          <el-form-item label="扫描原件" prop="originFileId" key="originFileId">
            <i class="el-icon-link"></i>
            <el-select v-model="rules.originFileId" filterable clearable>
              <el-option v-for="column in componentOPtions" :key="column.id" :label="column.name" :value="column.id"></el-option>
            </el-select>
          </el-form-item>
          <template v-if="component.properties.ocr.type === 'text'">
            <el-form-item label="识别内容" key="textContent">
              <i class="el-icon-link"></i>
              <el-select v-model="rules.textContent" filterable clearable>
                <el-option v-for="column in allowComponentOPtions" :key="column.id" :label="column.name" :value="column.id"></el-option>
              </el-select>
            </el-form-item>
          </template>
          <template v-else-if="component.properties.ocr.type === 'idCard'">
            <!-- 身份证-->
            <el-form-item :label="item.label" :key="item.value" v-for="item in idCardOptions">
              <i class="el-icon-link"></i>
              <el-select v-model="rules[item.value]" filterable clearable>
                <el-option v-for="column in allowComponentOPtions" :key="column.id" :label="column.name" :value="column.id"></el-option>
              </el-select>
            </el-form-item>
          </template>
          <template v-else-if="component.properties.ocr.type === 'receipt'">
            <!-- 票据-->
            <el-form-item :label="item.label" :key="item.value" v-for="item in receiptOptions">
              <i class="el-icon-link"></i>
              <el-select v-model="rules[item.value]" filterable clearable>
                <el-option v-for="column in allowComponentOPtions" :key="column.id" :label="column.name" :value="column.id"></el-option>
              </el-select>
            </el-form-item>
          </template>
        </el-form>
        <div slot="footer" class="ocr-rules-dialog-footer">
          <el-button @click="confirm" type="primary">确定</el-button>
          <el-button @click="ocrDialog.visible = false">取消</el-button>
        </div>
      </el-dialog>
    </div>
</template>

<script>
import { ProcessComponent } from '@/store/form/component'

export default {
  name: 'attr-ocr',
  props: ['component', 'currentNodeFormId'],
  inject: {
    formService: 'formService'
  },
  data () {
    return {
      rules: {},
      unWatch: null,
      ocrType: [
        {value: 'text', label: '通用文字'},
        {value: 'idCard', label: '身份证'},
        {value: 'receipt', label: '混贴票据'}
      ],
      // 注意value 和 接口回传的数据一一对应 执行时会直接取来做key, 修改时要确认
      idCardOptions: [
        {label: '住址', value: 'Address'},
        {label: '公民身份证号', value: 'IdNum'},
        {label: '出生日期', value: 'Birth'},
        {label: '姓名', value: 'Name'},
        {label: '性别', value: 'Sex'},
        {label: '民族', value: 'Nation'}
      ],
      receiptOptions: [
        {label: '金额', value: 'amount'},
        {label: '开票日期 ', value: 'billingTime'},
        {label: '费用类型', value: 'expenseType'},
        {label: '发票代码', value: 'invoiceCode'},
        {label: '发票号码', value: 'invoiceNumber'}
      ],
      ocrDialog: {
        visible: false
      },
      formRules: {
        originFileId: [{required: true, message: '请选择扫描原件', trigger: 'blur'}]
      },
      mainTableId: this.component.archive.tableId, // 文字识别不考虑放到表格里的情况
      isProcess: this.formService.getComponents().some(n => n instanceof ProcessComponent)
    }
  },
  computed: {
    // 拿到所有存在的控件的归档id
    allowlComponents () {
      let allowComponentsId = []
      let allComponents = []
      // currentNodeFormId 当前节点表单id
      allComponents = this.formService.getComponents().filter(e => {
        if (this.isProcess) {
          return e.componentType === 'rc-form' && e.id === this.currentNodeFormId
        } else {
          return e.componentType === 'rc-form'
        }
      })
      let notAllowComponents = ['rc-ocr']
      if (allComponents.length > 0) {
        allowComponentsId = allComponents[0].allChildren.map(e => !notAllowComponents.includes(e.componentType) && e.archive && e.archive.columnId)
      }
      return allowComponentsId
    },
    componentOPtions () {
      let componentOPtions = []
      let name = ''
      let id = ''
      this.formService.schema.tables.forEach(table => {
        table.columns.forEach(col => {
          if (!this.allowlComponents.includes(col.id)) {
            return false
          }
          name = col.name
          id = col.id
          // 非主表的情况下, 存入子表的tableId
          if (table.tableId !== this.mainTableId) {
            name = `${table.name}-${col.name}`
            id = `${table.tableId}+${col.id}`
          }
          componentOPtions.push({name: name, id: id})
        })
      })
      return componentOPtions
    },
    allowComponentOPtions () {
      let allowComponentOPtions = []
      if (!this.rules.originFileId) {
        return []
      } else if (this.rules.originFileId.includes('+')) {
        let tableId = this.rules.originFileId.split('+')[0]
        let table = this.formService.schema.tables.find(table => table.tableId === tableId)
        table.columns.forEach(col => {
          if (!this.allowlComponents.includes(col.id)) {
            return false
          }
          allowComponentOPtions.push({name: `${table.name}-${col.name}`, id: `${table.tableId}+${col.id}`})
        })
      } else {
        let table = this.formService.schema.tables.find(table => table.tableId === this.mainTableId)
        table.columns.forEach(col => {
          if (!this.allowlComponents.includes(col.id)) {
            return false
          }
          allowComponentOPtions.push({name: col.name, id: col.id})
        })
      }

      return allowComponentOPtions
    }
  },
  methods: {
    setRelationRules () {
      if (!this.component.properties.ocr.type) {
        return this.$message.warning('请先设置控件属性')
      }
      this.ocrDialog.visible = true
    },
    confirm () {
      this.$refs.ocrForm.validate(valid => {
        if (valid) {
          this.component.properties.ocr.rules = this.$_.cloneDeep(this.rules)
          this.ocrDialog.visible = false
        }
      })
    },
    openDialog () {
      if (Object.keys(this.component.properties.ocr.rules).length !== 0) {
        this.rules = this.$_.cloneDeep(this.component.properties.ocr.rules)
      }
      this.unWatch = this.$watch(() => { return this.rules.originFileId }, (val, oldVal) => {
        // 扫描原件改表且弹窗开着的时候重置下面的选项
        if ((val && oldVal && !val.includes('+') && !oldVal.includes('+')) || (oldVal && val.split('+')[0] === oldVal.split('+')[0])) {
          return false
        } else {
          Object.keys(this.rules).forEach(key => {
            if (key !== 'originFileId') {
              this.rules[key] = ''
            }
          })
        }
      })
    },
    closeDialog () {
      this.unWatch()
      this.$refs.ocrForm.clearValidate()
    }
  }
}
</script>

<style lang="scss">
.ocr{
  .ocr-rules{
    .el-form-item__content{
      width: 100%;
      position: relative;
      left: -100px;
      margin-top: 30px;
      .el-button{
        width: 100%;
        height: 24px;
        padding: 0;
        background:rgba(246,246,246,1);
        border:1px solid rgba(194,195,196,1);
        border-radius:4px;
      }
    }
  }
}

.ocr-rules-dialog .el-dialog{
  min-width: 540px;
  .el-form{
    .el-form-item:not(.is-required){
      .el-form-item__label{
        padding-left: 10px;
      }
    }
    .el-form-item__label{
      background:rgba(246,246,246,1);
      border-radius:2px;
    }
    .el-form-item__content{
      .el-form-item__error{
        position: absolute;
        left: 62px;
      }
      .el-icon-link{
        margin: 0 18px;
      }
      .el-select{
        width: calc(100% - 62px);
      }
    }
  }
  .ocr-rules-dialog-footer{
    text-align: center;
    .el-button{
      width: 104px;
      height: 30px;
      padding: 0;
    }
    .el-button+.el-button{
      color: rgba(84,171,241,1);
      border:1px solid rgba(84,171,241,1);
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/form/componentAttr/OCR.vue